export default function () {
  return {
    configurations: [],
    configurationsLoading: false,
    configurationsLoaded: false
  }
}
